import NidApp from "./nid/api.js";

require('imports-loader!history.js/history.js');
require('imports-loader!history.js/history.adapter.ender.js');

;
(function ($, nordsjo, NidApp) {

  var catId = 0;
  if (typeof nordsjo.currentCat !== 'undefined') {
    catId = nordsjo.currentCat.term_id;
  }

  var productListState = {
      propertySlugs: [],
      propertyIds: [],
      environmentalTag: '',
      environmentalSlug: '',
      orderableSlug: '',
      filterOrderable: false,
      catId: catId,
      catName: '',
      offset: window.location.search.split('offset=')[1] ? parseInt(window.location.search.split('offset=')[1]) : 0,
      orderby: 'title',
      order: 'ASC',
      postsPerPage: 10,
      catUrl: window.location.origin + window.location.pathname,
      url: window.location.origin + window.location.pathname,
      title: document.title,
      getRelatedProperties: 1
    },
    changeCat = false,
    firstLoad = true,
    propertyLists = {};

  var selectedTerms;


  /**
   * Trigger a change event in the history API & set a flag if we're changing main category.
   */
  function triggerUrlChange(changeMainCat) {
    changeCat = changeMainCat || false;

    var orderby = '',
      defaultOrderby = 'title';

    if (productListState.propertySlugs.length > 0) {
      var slugs = productListState.propertySlugs.join(',');
      productListState.url = productListState.catUrl + '?property=' + slugs;

      if (defaultOrderby !== productListState.orderby) {
        orderby = '&orderby=' + productListState.orderby + '&order=' + productListState.order;
      }

    } else {
      var hasGetParams = false;
      productListState.url = productListState.catUrl;
      if ('' !== window.location.search && false === changeCat) {
        hasGetParams = true;
        productListState.url += window.location.search;
      }

      if (defaultOrderby !== productListState.orderby) {
        if (true === hasGetParams) {
          orderby = '&';
        } else {
          orderby = '?';
        }
        orderby += 'orderby=' + productListState.orderby + '&order=' + productListState.order;
      }
    }

    if (true === changeCat) {
      productListState.environmentalSlug = '';
      productListState.environmentalTag = '';
      productListState.filterOrderable = false;

      // Show only the environmental choice for paint.
      var catPaintName = productListState.catName.toLowerCase();
      if (catPaintName.indexOf('färg') > -1 || catPaintName.indexOf('farge') > -1 || catPaintName.indexOf('maling') > -1) {
        $('.best-environmental-choice-container').show();
      } else {
        $('.best-environmental-choice-container').hide();
      }

      $(document.getElementById('best-environmental-check')).attr('checked', false);
      $(document.getElementById('orderable-check')).attr('checked', false);
      productListState.url = productListState.url.replace(/offset=(\d*)/, 'offset=0');
      productListState.offset = 0;
      productListState.title = productListState.catName + ' - ' + nordsjo.siteName;
    }

    if ('' !== productListState.environmentalSlug && -1 === productListState.url.indexOf('product_environmental_tags')) {
      if (productListState.url.indexOf('?') > -1) {
        productListState.url += '&';
      } else {
        productListState.url += '?';
      }
      productListState.url += 'product_environmental_tags=' + productListState.environmentalSlug;
    }

    if (false !== productListState.filterOrderable && -1 === productListState.url.indexOf('product_status')) {
      if (productListState.url.indexOf('?') > -1) {
        productListState.url += '&';
      } else {
        productListState.url += '?';
      }
      productListState.url += 'product_status=' + productListState.orderableSlug;
    }

    if (0 < productListState.offset && -1 === productListState.url.indexOf('offset')) {
      if (productListState.url.indexOf('?') > -1) {
        productListState.url += '&';
      } else {
        productListState.url += '?';
      }
      productListState.url += 'offset=' + productListState.offset;
    } else {
      productListState.url = productListState.url.replace(/offset=(\d*)/, 'offset=' + productListState.offset);
    }

    productListState.url += orderby;

    History.pushState(productListState, productListState.title, productListState.url);
  }


  /** Backbone Term stuff. */
  var Term = Backbone.Model.extend({});
  var Terms = Backbone.Collection.extend({
    model: Term,
    comparator: function (model) {
      return model.get('name').toLowerCase();
    }
  });

  var TermView = Backbone.View.extend({
    tagName: 'li',
    className: 'product-term',
    initialize: function () {
      this.listenTo(this.model, 'change', this.render);
      this.render();
    },
    render: function () {
      var model = this.model.toJSON();

      if (0 === +model.parent) {
        model.extraClass = 'main-category';
      } else {
        model.extraClass = '';
      }

      var template = _.template($('#nid-single-term-view').html())(model);
      this.$el.html(template);

      if (model.selected) {
        this.$el.find('a').addClass('selected');
      } else {
        this.$el.find('a').removeClass('selected');
      }

      return this;
    }
  });


  /** This is the view for the list of property terms. */
  var TermsView = Backbone.View.extend({
    className: 'product-term-list',
    initialize: function (options) {

      this.label = options.label;
      this.term_id = options.id;
      this.expanded = false
      this.collection.sort();
      this.listenTo(this.collection, 'add remove', this.sortList);
      this.listenTo(selectedTerms.collection, 'add remove', this.sortList);
      //this.listenTo( this.model, 'change', this.sortList );

      this.render();
    },
    sortList: function () {
      this.collection.sort();
      this.render();
    },
    getSelectedCount: function () {
      var termId = this.term_id
      var selected = selectedTerms.collection.where((item) => {
        return termId == item.get('parent');
      });

      return selected.length !== 0 ? selected.length : ''
    },
    render: function () {
      var $ul = $('<ul class="no-bullets property-term-list has-toggle" />'),
        $propList = $('.property-term-list', this.$el),
        $termsList;

      this.collection.each(function (term) {
        var termView = new TermView({
          model: term
        });

        $ul.append(termView.el);
      });

      let templateData = {
        label: this.label,
        count: this.getSelectedCount(),
        listClass: this.expanded ? 'expanded' : ''
      }

      var template = _.template($('#nid-terms-view').html())(templateData);
      this.$el.html(template);

      $ul.append('<a href="#" class="terms-close">' + nordsjo.tDone + '</a>');

      $('.terms-list', this.$el).html($ul);

      $('.terms-list', this.$el).prepend('<a href="#" class="terms-toggle"></a>');

      if (0 === $propList.length) {
        $('#product-property-container').append(this.$el);
      }
    },
    events: {
      'click .tax-term-property': 'toggleTermFilter',
      'click .terms-toggle': 'toggleOpen',
      'click .terms-close': 'toggleOpen'
    },
    toggleOpen: function (e) {
      e.preventDefault();

      //this.expanded = !this.expanded
      //console.log(propertyLists);

      let termId = this.term_id
      _.each(propertyLists, function (list) {
        if (list.term_id === termId) {
          list.expanded = !list.expanded
        } else {
          list.expanded = false
        }
        list.render()
      });

    },
    toggleTermFilter: function (e) {
      e.preventDefault();

      var $link = $(e.currentTarget),
        data = $link.data(),
        propertyList, model;

      propertyList = propertyLists[data.parent].collection;
      model = propertyList.findWhere({
        slug: data.slug
      });

      if (model.get('selected')) {
        model.set({
          selected: false
        });

        selectedTerms.collection.remove(model);
      } else {
        model.set({
          selected: true
        });

        selectedTerms.collection.add(model);
      }
    },
    addTermFilter: function (e) {
      e.preventDefault();

      var $link = $(e.currentTarget),
        data = $link.data(),
        propertyList, model;

      propertyList = propertyLists[data.parent].collection;
      model = propertyList.findWhere({
        slug: data.slug
      });

      model.set({
        selected: true
      });

      triggerUrlChange();
    },
    hideTerms: function () {
      var $links = $('li', this.$el);

      if ($links.length > this.numLinks) {
        $links.slice(this.numLinks).hide();
        $links.eq(this.numLinks).addClass('term-clear');
      }
    },
    destroy: function () {
      this.remove();
    }
  });


  /** This is the view for the list of selected property terms. */
  var SelectedTermsView = Backbone.View.extend({
    className: 'product-term-list selected-terms',
    initialize: function (options) {
      this.pageLoad = options.pageLoad || false;

      this.listenTo(this.collection, 'add', this.render);
      this.listenTo(this.collection, 'remove', this.render);
      this.listenTo(this.collection, 'reset', this.render);

      this.render();
    },
    termIsSelected: function (slug) {
      var term = this.collection.findWhere({
        slug: slug
      });
      return term !== undefined
    },
    render: function () {
      var $ul = $('<ul class="no-bullets property-term-list" />');

      this.collection.each(function (term) {
        var termView = new TermView({
          model: term
        });

        $ul.append(termView.el);
      });

      var template = _.template($('#nid-terms-view').html())({
        label: nordsjo.yourChoices,
        count: '',
        listClass: ''
      });
      this.$el.html(template);

      $('.terms-list', this.$el).html($ul);

      $('#selected-terms').append(this.$el);

      // Show/hide clear filters button

      if (this.collection.length > 0 && $('#remove-tax-filters').hasClass('is-hidden')) {
        $('#remove-tax-filters').removeClass('is-hidden');
      } else if (this.collection.length < 1 && !$('#remove-tax-filters').hasClass('is-hidden')) {
        $('#remove-tax-filters').addClass('is-hidden');
      }

      this.updateUrl();
    },
    events: {
      'click .tax-term-property': 'removeTermFilter'
    },

    /**
     * Remove a term from the selected list and add back to the
     * correct property terms list.
     */
    removeTermFilter: function (e) {
      e.preventDefault();

      var $link = $(e.currentTarget),
        data = $link.data();

      if ($link.hasClass('remove-tax-filters')) {
        this.removeFilters(data);
        return;
      }

      var selectedModel = selectedTerms.collection.findWhere({
        slug: data.slug
      });
      var generalModel = propertyLists[data.parent].collection.findWhere({
        slug: data.slug
      });

      // Set false on the model in the dropdown (terms view)
      generalModel.set({
        selected: false
      });

      // Remove the selected model (selected terms view)
      selectedTerms.collection.remove([selectedModel]);
    },

    /**
     * Remove all filters.
     */
    removeFilters: function (data) {
      selectedTerms.collection.each(function (model) {
        var parent = model.get('parent');
        propertyLists[parent].collection.add(model);
      });
      selectedTerms.collection.reset();
    },

    /**
     * Update the arrays of product Ids/slugs so that we can
     * append the correct history to the URL.
     */
    updateUrl: function () {
      productListState.propertySlugs.length = 0;
      productListState.propertyIds.length = 0;

      this.collection.each(function (term) {
        if (term.get('parent') > 0) {
          productListState.propertySlugs.push(term.get('slug'));
          productListState.propertyIds.push(term.get('term_id'));
        }
      });

      triggerUrlChange();
    },

    /** Destroy the view */
    destroy: function () {
      this.remove();
    }
  });

  /** Products category selector view. */
  var ProdCatView = Backbone.View.extend({
    events: {
      'click a.prod-tax-term': 'loadNewCategory'
    },

    /** Load a new product category. */
    loadNewCategory: function (e) {
      e.preventDefault();

      var $link = $(e.currentTarget);

      if ($link.hasClass('selected')) {
        return;
      }

      $('.prod-tax-term').removeClass('selected');
      $link.addClass('selected');

      productListState.catName = $('.term-name', $link).text();
      productListState.catId = $link.data('id');
      productListState.catUrl = $link.attr('href');
      productListState.url = productListState.catUrl;

      productListState.propertySlugs.length = 0;
      productListState.getRelatedProperties = 1;
      productListState.orderby = 'title';
      productListState.order = 'ASC';

      selectedTerms.collection.reset();

      $('#sort-product-order a').removeClass('active');
      $('#prod-sort-menu_order').addClass('active');

      triggerUrlChange(true);
    }
  });


  /** Products sort order view. */
  var ProdSortView = Backbone.View.extend({
    initialize: function () {
      $('#prod-sort-title').addClass('active');
    },

    events: {
      'click a': 'sortProducts'
    },

    /** Load a new category. */
    sortProducts: function (e) {
      e.preventDefault();

      var $link = $(e.currentTarget);
      if ($link.hasClass('active')) {
        return;
      }

      $('a', $('#sort-product-order')).removeClass('active');
      $link.addClass('active');

      productListState.orderby = $link.data('sort');

      if ('title' === productListState.orderby || 'menu_order' === productListState.orderby || 'menu_order title' === productListState.orderby) {
        productListState.order = 'ASC';
      } else {
        productListState.order = 'DESC';
      }

      triggerUrlChange();
    }
  });


  /** Render the list of product properties assosicated to the current category. */
  function renderRelatedProperties(properties) {
    // Remove the current lists.
    _.each(propertyLists, function (list) {
      list.destroy();
    });
    propertyLists = {};

    // Remove selected product properties, but not on page load.
    if (false === firstLoad) {
      selectedTerms.collection.reset();
    }
    firstLoad = false;

    // Sort the properties in alphabetical order.
    properties = _(properties).sortBy(function (property) {
      return property.name.toLowerCase();
    });


    // Render the property lists,
    _.each(properties, function (property) {
      var children = [],
        terms;

      // Don't add selected terms to the collection.
      _.each(property.children, function (child) {
        if (_.indexOf(productListState.propertyIds, +child.term_id) != -1) {
          child.selected = true;
        }

        children.push(child);
      });

      terms = new Terms(children);

      propertyLists[property.term_id] = new TermsView({
        collection: terms,
        label: property.name,
        id: property.term_id
      });
    });

  }

  // Reset/remove all filters

  $('#remove-tax-filters').on('click', function (e) {
    e.preventDefault();

    selectedTerms.collection.reset();

    _.each(propertyLists, function (list) {
      _.each(list.collection.models, function (model) {
        model.set({
          selected: false
        });
      });

      list.render();
    });

    selectedTerms.updateUrl(true);
  });


  $(function () {

    var $productList = $(document.getElementById('tax-product-listing')),
      $productListParent = $productList.closest('.products-container'),
      $moreButton = $(document.getElementById('load-more-products')),
      $prodPropContainer = $(document.getElementById('product-property-container')),
      $propToggle = $(document.getElementById('property-toggle')),
      $enviromentalToggle = $(document.getElementById('best-environmental-check')),
      $shoppingcartToggle = $(document.getElementById('orderable-check')),
      $body = $('body');


    //$prodPropContainer.hide();

    // Show/hide toggle for product property filters.
    /*$propToggle.on( 'click', function( e ) {
    	e.preventDefault();
    	var $this = $( this );

    	if ( $this.hasClass( 'open' ) ) {
    		$this.removeClass( 'open' ).removeClass( 'show-store-trigger' ).removeClass( 'active' ).find( 'span' ).text( nordsjo.showFilters );
    		$prodPropContainer.slideUp( 350, calcHeights );
    	} else {
    		$this.addClass( 'open').addClass( 'show-store-trigger' ).addClass( 'active' ).find( 'span' ).text( nordsjo.hideFilters );
    		$prodPropContainer.slideDown( 350, calcHeights );
    	}
    });


    var calcHeights = function() {
    	$.each( $( '.property-term-list' ), function() {
    		NidApp.calcListHeight( $( this ) );
    	});
    };*/

    // Environmental Tag
    /*$enviromentalToggle.on( 'change', function( e ) {
    	var $this = $( this );

    	if ( $this.is( ':checked' ) ) {
    		productListState.environmentalTag  = +$this.val();
    		productListState.environmentalSlug = $this.data( 'slug' );
    	} else {
    		productListState.environmentalTag  = '';
    		productListState.environmentalSlug = '';
    	}

    	triggerUrlChange();
    });*/

    // Shoppingcart status
    $shoppingcartToggle.on('change', function (e) {
      var $this = $(this);
      productListState.orderableSlug = $this.data('slug');

      if ($this.is(':checked')) {
        productListState.filterOrderable = true;
      } else {
        productListState.filterOrderable = false;
      }

      triggerUrlChange();
    });

    // For a regular page load, show the selected terms.
    _.each(nordsjo.currentProperties, function (term) {
      productListState.propertyIds.push(term.term_id);
      productListState.propertySlugs.push(term.slug);
    });

    var terms = new Terms(nordsjo.currentProperties);
    selectedTerms = new SelectedTermsView({
      collection: terms,
      pageLoad: true
    });


    /** Render the properties on page load. */
    renderRelatedProperties(nordsjo.productProperties);


    /** Render the category selctor view. */
    var prodCatView = new ProdCatView({
      el: $('#tax-product_cat')
    });


    /** Render the sort order view. */
    var prodSortView = new ProdSortView({
      el: $('#sort-product-order')
    });


    /** Bind the product filtering to history 'statechange'. */
    History.Adapter.bind(window, 'statechange', filterProductsList);


    /** Re-render the product listing by taxonomy and / or orderby paramaters. */
    function filterProductsList(args) {
      var vars = $.extend({
        append: false
      }, args);

      if ($productListParent.hasClass('loading')) {
        return;
      }
      $productListParent.addClass('loading');

      var products = NidApp.renderProducts(productListState);

      $.when(products).done(function (result) {
        if (productListState.catId > 0 && !$body.hasClass('tax-active')) {
          $body.addClass('tax-active');
        }
        $productListParent.removeClass('loading');

        if (true === result.success) {

          $('[data-product-count]').text(result.data.foundPosts);

          if (typeof result.data.termDesc !== 'undefined') {
            $('.term-description').html(result.data.termDesc);
          }

          if (true === changeCat) {
            renderRelatedProperties(result.data.relatedProperties);
            $('h1.page-title').text(productListState.catName);
            $('.breadcrumb_last').text(productListState.catName);
          }

          if (result.data.posts.length === 0) {
            $productList.html('<li>' + nordsjo.noProductsFound + '</li>');

          } else {
            if (false === vars.append) {
              $productList.hide().html(result.data.posts).fadeIn();

            } else {
              var $products = $(result.data.posts).hide();
              $products.appendTo($productList).fadeIn();

            }

          }

          updatePaginationButton(result.data);
        }

      });
    }


    /** Disable pagination on page load if there are less than 10 posts */
    function maybeDisablePagination() {
      if ($('li', $productList).length < productListState.postsPerPage) {
        $moreButton.addClass('disabled');
      }
    }
    maybeDisablePagination();


    /** Update the pagination button after an AJAX call. */
    function updatePaginationButton(query) {
      if ('empty' === query) {
        $moreButton.addClass('disabled');
        return;
      }

      if (typeof query.foundPosts !== 'undefined') {
        query.foundPosts = +query.foundPosts;

        if (query.foundPosts === query.postCount || $('li', $productList).length === query.foundPosts) {
          $moreButton.addClass('disabled');

        } else {
          $moreButton.removeClass('disabled');

        }
      }
    }


    /** Load more products & append to the products list. */
    function loadMoreProducts(e) {
      e.preventDefault();

      if ($(e.currentTarget).hasClass('disabled')) {
        return false;
      }

      productListState.offset += productListState.postsPerPage;

      filterProductsList({
        append: true
      });
      triggerUrlChange();
    }

    $moreButton.on('click', loadMoreProducts);

  });

}(jQuery, nordsjo, NidApp));
